"use strict";
/**
 * Venue Status Polling Service
 *
 * Slow-polls GET /api/venue-status and publishes the result to global state,
 * where the corner health-dot indicator renders it. Independent of market /
 * orderbook polling (which the state handler owns) — this is a single
 * app-global poller with one start site, so it does not conflict with the
 * "polling has one owner" rule (that rule governs market polling).
 *
 * The endpoint requires a session, so each tick is skipped while logged out.
 * Errors are swallowed quietly: a failed status poll must never surface as a
 * user-facing error, and the last-known snapshot simply persists.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.startVenueStatusPolling = startVenueStatusPolling;
exports.stopVenueStatusPolling = stopVenueStatusPolling;
const api_1 = require("../api");
const state_1 = require("../state");
// Venue health changes are coarse (server debounces over ~20s heartbeats), so
// a relaxed cadence is plenty and keeps this off any hot path.
const VENUE_STATUS_POLL_INTERVAL_MS = 10000;
let pollTimer = null;
async function pollOnce() {
    if (!(0, state_1.getState)().isAuthenticated) {
        return;
    }
    try {
        const venueStatus = await (0, api_1.fetchVenueStatus)();
        (0, state_1.updateState)({ venueStatus });
    }
    catch {
        // Non-fatal: keep the last-known snapshot; try again next tick.
    }
}
/**
 * Start the venue-status poller. Idempotent — safe to call more than once.
 * Started once from initApp; runs for the life of the page.
 */
function startVenueStatusPolling() {
    if (pollTimer !== null) {
        return;
    }
    void pollOnce();
    pollTimer = window.setInterval(() => void pollOnce(), VENUE_STATUS_POLL_INTERVAL_MS);
}
/** Stop the poller (test cleanup / teardown). */
function stopVenueStatusPolling() {
    if (pollTimer !== null) {
        window.clearInterval(pollTimer);
        pollTimer = null;
    }
}
